import { postService } from '../../utilities/request/restClient'

export const uploadDocuments = (payload) =>
    postService(`/v1/document/uploadFiles`, payload)

export const uploadImage = (payload) =>
    postService(`/v1/document/upload`, payload)
